import Phaser from "phaser";
import bestPanelBg from "@assets/imgs/home/best-panel.png";

export class BestPanel extends Phaser.GameObjects.Container {
  private bg: Phaser.GameObjects.Image;
  private label: Phaser.GameObjects.Text;
  private text: Phaser.GameObjects.Text;

  static preload(scene: Phaser.Scene) {
    scene.load.image("best-panel-bg", bestPanelBg);
  }

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    this.bg = scene.add.image(0, 0, "best-panel-bg").setOrigin(0.5);

    const BG_WIDTH = 214;
    const BG_HEIGHT = 73;

    this.label = scene.add
      .text(-BG_WIDTH / 2 + 6, -BG_HEIGHT / 2 + 6, "BEST", {
        fontFamily: "Luckiest Guy",
        fontSize: "30px",
        color: "#1C120E",
      })
      .setOrigin(0, 0);

    this.text = scene.add
      .text(BG_WIDTH / 2 - 12, BG_HEIGHT / 2 - 8, "0", {
        fontFamily: "Luckiest Guy",
        fontSize: "40px",
        color: "#ffffff",
        stroke: "#1C120E",
        strokeThickness: 8,
      })
      .setOrigin(1, 1);

    this.add([this.bg, this.label, this.text]);
  }

  setBest(best: number) {
    this.text.setText(best.toLocaleString());
  }
}
